import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-buy-upgrade-error',
    templateUrl: './buy-upgrade-error.component.html',
    styleUrls: ['./buy-upgrade-error.component.css']
})
export class BuyUpgradeErrorComponent implements OnInit {

    title: string = 'CI DISPIACE';
    description: string = 'Si è verificato un errore durante l\'aggiornamento della gara';
    error: string;

    constructor(
        private router: Router
    ) { }

    ngOnInit(): void {
        const error = localStorage.getItem('BUY_UPGRADE_ERROR');
        if (error && error !== 'undefined') {
            this.error = error;
            console.log(error);
        }
    }

    goToTenders() {
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'tenders' } });
    }

}
